module.exports = __webpack_public_path__ + "img/oficina-mayorista.81aa8582.jpg";